<script setup lang="ts">
const indexStore = useIndexStore();
import AuthService from "~/plugins/authService";

const { open, text } = defineProps(["open", "text"]);
const runtimeConfig = useRuntimeConfig();

const close = () => {
  indexStore.resetModal();
};
const login = () => {
  AuthService.login();
};
const registerUrl = computed(() => {
  return runtimeConfig.public.communityBaseUrl;
});
</script>

<template>
  <div v-if="open" class="modal">
    <div class="modal-backdrop" @click="close()"></div>
    <div class="modal-content">
      <div class="header">
        <div></div>
        <h4>OPS!</h4>
        <button type="button" @click="close()">
          <MGIcon size="2x" icon="close" />
        </button>
      </div>
      <p>{{ text }}</p>
      <button
        type="button"
        class="btn primary login-button lg px-4 block mb-2"
        @click="login"
      >
        {{ $t("header.login.btn_login") }}
      </button>

      <div class="card">
        <div>
          {{ $t("header.login.register_message")
          }}<a :href="`${registerUrl}/register`">{{
            $t("header.login.btn_register")
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal {
  position: fixed;
  display: block;
  width: 100%;
  height: 100vh;
}

.modal-backdrop {
  position: fixed;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  height: 100vh;
  z-index: 1;
  left: 0;
  top: 0;
  display: block;
}

.modal-content {
  border: 1px solid var(--header-ui-config-border);
  border-radius: 0;
  width: 366px;
  padding: 2rem;
  position: absolute;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 0.875rem;
  background-color: var(--modal-user-bg);
  color: var(--active);
  z-index: 2;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    margin-bottom: 0.5rem;
    h4 {
      margin: 0;
    }
    > div {
      width: 19px;
    }
    button {
      background: none;
      padding: 0;
      border: none;
      > i {
        color: #aaaaaa;
      }
    }
  }

  h4 {
    font-size: 1.125rem;
    font-weight: 600;
  }
  p {
    max-width: 270px;
    font-size: 14px;
    text-align: center;
  }
  > button {
    width: 100%;
  }

  .card {
    width: 100%;
    border-radius: 0;
    border: none;
    background-color: var(--body-bg-card);
    padding: 10px;
    display: block;
    color: var(--inactive);
    a {
      display: inline-block;
      font-weight: bold;
      color: var(--chip-text);
      margin-left: 8px;
    }
  }
}
</style>
